import classNames from "classnames";
import ArrowLeftIconSvg from "PFIcons/arrow_left.svg";
import EditIconSvg from "PFIcons/edit.svg";
import TrashIconSvg from "PFIcons/trash.svg";
import React from "react";

import css from "./booking_note_actions.module.scss";

interface IProps {
  editMode: boolean;
  disabled?: boolean;
  onEditClick: () => void;
  onDeleteClick: () => void;
}

const CancelIcon = (props) => (
  <ArrowLeftIconSvg className={classNames(css.icon)} width={10} height={10} {...props} />
);
const EditIcon = (props) => <EditIconSvg className={css.icon} width={10} height={10} {...props} />;
const DeleteIcon = (props) => <TrashIconSvg {...props} />;

const BookingNoteActions = ({ editMode, disabled, onEditClick, onDeleteClick }: IProps) => (
  <div className={css.root}>
    <button onClick={onEditClick} disabled={disabled}>
      {editMode ? <CancelIcon /> : <EditIcon />}
    </button>
    <button onClick={onDeleteClick} disabled={disabled}>
      <DeleteIcon className={css.icon} width={14} height={14} />
    </button>
  </div>
);

export default BookingNoteActions;
